module.exports = __webpack_public_path__ + "static/media/coop-pms-295.f674dd6b.jpg";